(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cellin-product-main"] && !Shopify.designMode) return;
  try {
    

  /* Pre-order button: add via Shopify cart actions and open the cart drawer (rhode-style).
     Falls back to the normal form post (→ /cart) if the actions aren't available or fail. */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-cellin-product-form]');
    const actions = window.Shopify?.actions;
    if (!form || !actions?.updateCart || form.dataset.submitting) return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    const attributes = [];
    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) attributes.push({ key: match[1], value: String(value) });
    }

    button?.setAttribute('aria-busy', 'true');
    try {
      const result = await actions.updateCart(
        {
          lines: [
            {
              merchandiseId: `gid://shopify/ProductVariant/${data.get('id')}`,
              quantity: Number(data.get('quantity') || 1),
              attributes,
            },
          ],
        },
        { event: { context: 'product' } }
      );
      if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
      await actions.openCart?.();
    } catch (error) {
      console.warn('[cellin] add to cart via actions failed, falling back', error);
      form.dataset.submitting = 'true';
      form.submit();
    } finally {
      button?.removeAttribute('aria-busy');
    }
  });
  if (!customElements.get('cellin-gallery')) {
    customElements.define(
      'cellin-gallery',
      class CellinGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.cellin-gallery__track');
          this.slides = [...this.track.children];
          if (this.slides.length < 2) return;

          this.prev = this.querySelector('.cellin-gallery__arrow--prev');
          this.next = this.querySelector('.cellin-gallery__arrow--next');
          const dots = this.querySelector('.cellin-gallery__dots');
          this.dots = this.slides.map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'cellin-gallery__dot';
            dot.setAttribute('aria-label', `Show image ${i + 1}`);
            dot.addEventListener('click', () => this.go(i));
            dots.append(dot);
            return dot;
          });
          [this.prev, this.next, dots].forEach((el) => (el.hidden = false));

          this.prev.addEventListener('click', () => this.go(this.index - 1));
          this.next.addEventListener('click', () => this.go(this.index + 1));
          this.track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.go(this.index - 1);
            if (event.key === 'ArrowRight') this.go(this.index + 1);
          });
          this.track.tabIndex = 0;
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.update();
          this.setupAutoplay();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.observer?.disconnect();
        }

        /* Auto-advance every data-autoplay-ms, looping to the first image. Pauses on hover/focus,
           off-screen or in a hidden tab; stops for good once the shopper navigates themselves.
           Off for visitors who prefer reduced motion. */
        setupAutoplay() {
          const delay = Number(this.dataset.autoplayMs);
          if (!delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.paused = new Set();
          const pause = (reason) => this.paused.add(reason);
          const resume = (reason) => this.paused.delete(reason);
          const stop = () => {
            clearInterval(this.timer);
            this.timer = null;
          };

          this.addEventListener('mouseenter', () => pause('hover'));
          this.addEventListener('mouseleave', () => resume('hover'));
          this.addEventListener('focusin', () => pause('focus'));
          this.addEventListener('focusout', () => resume('focus'));
          ['pointerdown', 'wheel', 'keydown'].forEach((type) =>
            this.addEventListener(type, stop, { passive: true })
          );
          if (document.hidden) pause('hidden');
          document.addEventListener('visibilitychange', () =>
            document.hidden ? pause('hidden') : resume('hidden')
          );
          this.observer = new IntersectionObserver(([entry]) =>
            entry.isIntersecting ? resume('offscreen') : pause('offscreen')
          );
          this.observer.observe(this);

          this.timer = setInterval(() => {
            if (this.paused.size) return;
            const next = this.index + 1;
            this.go(next >= this.slides.length ? 0 : next);
          }, delay);
        }

        get index() {
          return Math.round(this.track.scrollLeft / this.track.clientWidth);
        }

        go(i) {
          const target = Math.max(0, Math.min(i, this.slides.length - 1));
          this.track.scrollTo({ left: target * this.track.clientWidth });
        }

        update() {
          const i = this.index;
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
          this.prev.disabled = i === 0;
          this.next.disabled = i === this.slides.length - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
